export default "__VITE_ASSET__B__$UMrR__"